var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBranchSvgrepo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_386)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.87527 8.38059V20.125H14.6196C14.8626 20.8119 15.2757 21.4261 15.8203 21.9103C16.3648 22.3945 17.0232 22.7328 17.7338 22.8937C18.4445 23.0547 19.1844 23.033 19.8844 22.8307C20.5844 22.6283 21.2218 22.252 21.737 21.7367C22.2523 21.2215 22.6286 20.5841 22.8309 19.8841C23.0333 19.1841 23.055 18.4442 22.894 17.7335C22.7331 17.0229 22.3948 16.3645 21.9106 15.82C21.4264 15.2754 20.8122 14.8623 20.1253 14.6193V8.38059C21.0848 8.04148 21.8935 7.37406 22.4085 6.49631C22.9235 5.61856 23.1116 4.587 22.9396 3.58396C22.7676 2.58092 22.2465 1.671 21.4684 1.01503C20.6904 0.359052 19.7054 -0.000732422 18.6878 -0.000732422C17.6701 -0.000732422 16.6852 0.359052 15.9071 1.01503C15.129 1.671 14.6079 2.58092 14.4359 3.58396C14.2639 4.587 14.452 5.61856 14.967 6.49631C15.482 7.37406 16.2907 8.04148 17.2503 8.38059V14.6193C16.6436 14.8344 16.0927 15.1822 15.6376 15.6373C15.1825 16.0924 14.8347 16.6433 14.6196 17.25H5.75027V8.38059C6.70979 8.04148 7.51853 7.37406 8.03353 6.49631C8.54854 5.61856 8.73665 4.587 8.56462 3.58396C8.39259 2.58092 7.87148 1.671 7.09342 1.01503C6.31536 0.359052 5.33045 -0.000732422 4.31277 -0.000732422C3.29508 -0.000732422 2.31017 0.359052 1.53211 1.01503C0.754047 1.671 0.232946 2.58092 0.0609131 3.58396C-0.11112 4.587 0.076992 5.61856 0.591999 6.49631C1.10701 7.37406 1.91574 8.04148 2.87527 8.38059ZM20.1253 17.25V20.125H17.2503V17.25H20.1253ZM20.1253 2.87497V5.74997H17.2503V2.87497H20.1253ZM5.75027 2.87497V5.74997H2.87527V2.87497H5.75027Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "matrix(-1 0 0 1 23 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchSvgrepo);
export default __webpack_public_path__ + "static/media/branch-svgrepo.8a5ad1fb25549b1f8e55e5a9c3c7ebdc.svg";
export { ForwardRef as ReactComponent };